/*
 * HelpScreen4
 * ==========
 */
import HelpBase from '../ui/HelpBase'

export default class HelpScreen4 extends HelpBase {

  constructor (game, screens) {
    super(game);

    this.screens = screens;

    this.page = 4;

    this.params = {
      'helpFunTextP': [2, 87],
      'helpFunArrowP': [-15, -164],
      'helpFunGridP': [-96, -45],
      'helpFunUiP': [0, -310],
      'helpFunTextL': [107, 77],
      'helpFunArrowL': [-83, 118],
      'helpFunGridL': [-16, -46],
      'helpFunUiL': [-242, 109],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, 203],
      'nextP': [107, 203],
      'exitP': [2, 203]
    };

    this.helpFunTextP = this.addSprite('helpFunTextP', 'helpScreens', 'helpFunText.png', 'p');
    this.helpFunArrowP = this.addSprite('helpFunArrowP', 'helpScreens', 'helpFunArrow.png', 'p');
    this.helpFunGridP = this.addSprite('helpFunGridP', 'helpScreens', 'helpFunGrid.png', 'p');
    this.helpFunUiP = this.addSprite('helpFunUiP', 'helpScreens', 'helpFunUi.png', 'p');

    this.helpFunTextL = this.addSprite('helpFunTextL', 'helpScreens', 'helpFunText.png', 'l');
    this.helpFunArrowL = this.addSprite('helpFunArrowL', 'helpScreens', 'helpFunArrow.png', 'l');
    this.helpFunGridL = this.addSprite('helpFunGridL', 'helpScreens', 'helpFunGrid.png', 'l');
    this.helpFunUiL = this.addSprite('helpFunUiL', 'helpScreens', 'helpFunUiLandscape.png', 'l');

    this.helpFunArrowL.rotation = -Math.PI / 2;
    this.helpFunArrowL.scale.x = -1;
    this.initHelpButtons();

    this.setInputForAllButtons(false)
  }

}
